import React from "react";

const category = [
  { id: 1, name: "Legal", displayOn: ["en", "cn", "ru"] },
  { id: 2, name: "Construction", displayOn: ["en", "cn", "ru"] },
  {
    id: 3,
    name: "Estate and property management",
    displayOn: ["en", "cn", "ru"],
  },
  { id: 4, name: "Owner benefits", displayOn: ["en", "cn", "ru"] },
  { id: 5, name: "Financing", displayOn: ["en", "cn", "ru"] },
];

const faqs = [
  {
    categoryId: 1,
    question: {
      en: "What types of ownership are available?",
      ru: "Какая форма собственности предоставляется?",
      cn: "产权有哪些类型？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Condominiums are available on a freehold basis
            for both Thai and non-Thai buyers. However, according to current
            Thai law, non-Thais may only purchase up to 49% of the condominium’s
            saleable area on a freehold basis. Otherwise, they may purchase any
            remaining units on a renewable leasehold basis (currently for a
            maximum period of 30 years as permitted by law).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Полное право собственности (freehold) на
            недвижимость доступно для покупателей, как являющихся, так и не
            являющихся гражданами Таиланда. Однако, согласно действующему
            тайскому законодательству, лица, не являющиеся гражданами Таиланда,
            могут приобрести только до 49% выставленной на продажу площади с
            полным правом собственности. При этом оставшаяся часть площади может
            быть приобретена на основе долгосрочной аренды (leasehold) с
            возможностью продления, на данный момент максимальный срок,
            разрешенный законом, составляет 30 лет.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            泰国国籍与非泰国国籍买家都可以持有公寓。然而，根据目前的泰国法律，非泰国国籍买家可持有一个公寓项目的永久业权不得超过可销售面积的49%。除此以外，他们可以用购买可续租租赁产权的形式拥有剩余额度的单位（目前法律规定最长的租赁期限为）。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en:
        "What are the costs associated with the lease / freehold registration?",
      ru: "Какова стоимость регистрации долгосрочной аренды (лизхолда)?",
      cn: "租赁登记的相关费用有哪些？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Lease registration fees and stamp duty (currently 1.1% of the lease
            premium) is payable to the Land Department upon registration of the
            lease. The cost of lease renewals will be borne by the lessee
            according to the contracts.
          </p>
          <p>
            Freehold registration fees (currently 2.0% of the appraisal price)
            is payable to the Land Department upon transfer and registration of
            title. The appraisal price is assessed by the Thailand’s Treasury
            Department which is generally below market value. Other applicable
            taxes upon transfer and registration of freehold title are:
          </p>
          <ul>
            <li>
              <strong>Corporate Income Withholding Tax</strong>
            </li>
            <p>
              (currently 1.0% of the selling price or appraisal price, whichever
              is higher)
            </p>
            <li>
              <strong>Specific Business Tax</strong>
            </li>
            <p>
              (currently 3.3% of the selling price or appraisal price, whichever
              is higher)
            </p>
          </ul>
          <p>
            The burden between seller and buyer for the above costs will be
            specified in the relevant agreements.
          </p>
          <p>
            <small>
              <em>
                Note: Applicable rates stated are current and may be subject to
                change.
              </em>
            </small>
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Сбор за регистрацию долгосрочной аренды и государственная пошлина (в
            настоящее время составляет 1,1% от стоимости) выплачиваются
            Земельному департаменту при регистрации. Продление долгосрочной
            аренды оплачивается арендатором в соответствии с условиями договора.
            Расходы на продление аренды несет арендатор.
          </p>
          <p>
            Плата за регистрацию полного права собственности (в настоящий момент
            2,0% от оценочной стоимости) выплачивается Земельному Департаменту
            после передачи и оформления правасобственности. Оценочная стоимость
            рассчитывается по государственной ставке налогоо ложения, размер
            которой обычно ниже рыночной стоимости. Другие взимаемые налоги при
            передаче и оформлении полного права собственности включают:
          </p>
          <ul>
            <li>
              <strong>Налог на доходы юридических лиц</strong>
            </li>
            <p>
              (на сегодняшний день 1,0% от стоимости продажи или оценочной
              стоимости, в зависимости от того, какая из них выше)
            </p>
            <li>
              <strong>Специальный налог на прибыль</strong>
            </li>
            <p>
              (на сегодняшний день 3,3% от стоимости продажи или оценочной
              стоимости, в зависимости от того, какая из них выше).
            </p>
          </ul>
          <p>
            Обязательства продавца и покупателя в отношении указанных выше
            расходов описываются в соглашении о купле-продажи / или договоре о
            долгосрочной аренде.
          </p>
          <p>
            <small>
              <em>
                Примечание: указанные ставки действительны на настоящий момент и
                могут быть пересмотрены.
              </em>
            </small>
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            租赁登记费和印花税（目前为租赁费的1.1%）应在租赁登记结束后向土地管理部门缴纳。续租费用按合同规定由承租人承担。
          </p>
          <p>
            转让与登记所有权时，需向地政局支付永久产权登记费（目前为评估价的2.0％）。评估价格由泰国财政部评估，一般来说相对低于市场价值。其他转让与登记永久业权的适用税额为：
          </p>
          <ul>
            <li>
              <strong>企业所得税</strong>
            </li>
            <p>（为目前销售价格或评估价格的1.0％，以较高者为准）</p>
            <li>
              <strong>特定商业税</strong>
            </li>
            <p>（为目前销售价格或评估价格的3.3％，以较高者为准）</p>
          </ul>
          <p>有关卖方和买方之间的上述费用负担，将在有关协议中有所规定。</p>
          <p>
            <small>
              <em>注：所列的适用费率为最新价格，可能会有变动。</em>
            </small>
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en: "Is a leasehold condominium transferable?",
      ru:
        "Может ли передаваться право на недвижимость, приобретенную на правах долгосрочной аренды?",
      cn: "问.租赁公寓可否转让？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Yes. Leasehold condominiums may be transferred
            subject to the terms and conditions of the lease agreement.
            Generally, a small fee is payable. In addition, the new owner must
            agree to be bound by the terms and conditions contained in the
            original lease agreement.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Да, право на недвижимость, приобретенную на
            правах долгосрочной аренды, может передаваться согласно положениям
            договора аренды. Обычно за это взимается небольшая плата. Также
            новый владелец должен принять условия, прописанные в изначальном
            договоре аренды.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            可以的。租赁公寓可根据租赁协议的条款与条件进行转让。通常需支付少额费用。此外，新业主必须同意遵守原租赁协议中所含的条款与条件。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en: "Is leasehold ownership secure?",
      ru: "Защищено ли право долгосрочной аренды?",
      cn: "租赁所有权安全吗？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Leasehold ownership is a common method of
            ownership for foreign buyers. Once the lease is registered at the
            Land Department, the lessee’s rights over the condominium unit will
            be officially recognized.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Владение собственностью на правах долгосрочной
            аренды – довольно распространенный вид владения для иностранных
            покупателей. После оформления права долгосрочной аренды в Земельном
            Департаменте право арендатора на собственность признается
            официально.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            “租赁产权”是一种常见于外国买家持有本国物业的方式。一旦租赁产权证在地政局登记之后，业主对公寓拥有的权利便获得官方认可。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en:
        "When will the registration and transfer of the condominiums take place?",
      ru: "Когда произойдет оформление и передача прав собственности?",
      cn: "公寓何时可进行登记和转让？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Approximately 180 days after full payment has
            been received and construction of all buildings in the Project are
            completed and condominium license is obtained. We will notify the
            owner of any documents and fees required for registration. Owners
            may opt to accept the hand-over of their purchased/leased unit and
            move in before registration and transfer of condominium unit
            ownership, upon the occupancy permit of the building being granted
            (terms and conditions apply).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Приблизительно спустя 90 дней после получения
            полной оплаты и окончания строительства. Мы уведомим владельца о
            том, какие документы и пошлины необходимы для регистрации. Владельцы
            могут начать пользоваться своей квартирой и вьехать до регистрации
            ипередачи права собственности на квартиру в кондоминиуме при наличии
            разрешения на проживание в этом здании (применяются условия).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            收到全额付款后约90天，且项目中所有建筑的施工完成后。我们将会知会业主登记所需的所有文件和费用。一旦项目获得建筑物的入住许可证，业主可选择接受其购买/租赁单位的移交，并在公寓单位所有权登记及转移手续完成前入住（需满意一定条件及条款）。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en: "Should I appoint a lawyer to review the agreements?",
      ru: "Требуется ли проверка соглашений юристом?",
      cn: "我应指定律师审核协议吗？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Our agreements have been used for a number of
            years and have been reviewed by major international law firms. We
            have our own in-house legal team which will assist to clarify any
            questions you may have concerning the agreements. However, should
            you wish to obtain specific advice regarding the structuring of your
            investment, we recommend you consult with a professional legal
            and/or financial adviser.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Наши договора используются уже несколько лет и
            прошли проверку крупнейшими международными юридическими компаниями.
            Специалисты нашего юридического отдела ответят на все связанные с
            соглашениями вопросы, которые могут у вас возникнуть. В то же время,
            если вы хотите получить конкретные рекомендации относительно
            структуризации своих инвестиций, мы советуем вам обратиться к
            профессиональному юридическому и/или финансовому консультанту.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            我们的协议文本已使用多年，且已通过多家大型国际律师事务所的审核。我们拥有自己的内部法律团队，他们会帮助解释您对协议可能存在的任何问题。但是，如果您希望获得有关投资结构的具体建议，我们建议您咨询专业法律和/或财务顾问。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: {
      en:
        "What types of visas are available for foreigners to stay in Thailand?",
      ru: "Какие типы виз позволяют иностранцу находиться в Таиланде?",
      cn: "外籍人士将能获得何种泰国居留签证？",
    },
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> There are various forms of visas available to
            foreigners who wish to enter Thailand for study, business,
            investment, retirement and other purposes ranging from 90 days to 10
            years multiple entry which include.
          </p>
          <ul>
            <li>
              Long-Term Resident (LTR) visa offering 10 year renewable visas for
              four categories of foreign nationals: wealthy global citizens,
              wealthy pensioners, work-from-Thailand professionals, and
              highly-skilled professionals - subject to meeting qualification.
            </li>
            <li>
              Retirement visa for people aged 50 years or over and meet
              financial requirements
            </li>
            <li>
              Education visa when enrolled at registered education institution
              within Thailand
            </li>
            <li>Business visa when operating a business</li>
            <li>Marriage visa for foreigners married to a Thai</li>
            <li>
              Thailand Elite Visa - a government led program offering
              memberships including 5 to 20 year visas
            </li>
          </ul>
          <p>
            Please consult with an immigration specialist or Thai Embassy /
            Consulate for more information.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Для граждан других стран, желающих въехать в
            Таиланд в учебных, деловых или инвестиционных целях, с целью выхода
            на пенсию и в других целях, предусмотрены разные формы виз,
            действительные от 90 дней до 1 года и предоставляющие право
            многократного въезда в страну, включая:
          </p>
          <ul>
            <li>
              Образовательную визу — при зачислении в зарегистрированное
              образовательное учреждение в Таиланде;
            </li>
            <li>Бизнес-визу — для управляющих или сотрудников компаний;</li>
            <li>
              Пенсионную визу — для лиц в возрасте 50 лет и старше,
              соответствующих финансовым требованиям;
            </li>
            <li>
              Визу для заключения брака — для граждан других стран, вступающих в
              брак с гражданином/гражданкой Таиланда;
            </li>
            <li>
              Визу «Элита Таиланда» — выдается сроком на 5 лет в рамках
              государственной программы, которая также предусматривает другие
              привилегии.
            </li>
          </ul>
          <p>
            За дополнительной информацией обращайтесь к иммиграционному
            специалисту посольства
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            对于希望前往泰国学习、出差、投资、享受退休生活或因其他目的前往泰国的外籍人士，当局提供多种形式且期限介于
            90 天至 10年的多次入境签证，其中包括：
          </p>
          <ul>
            <li>
              <ul>
                <li>
                  长期居民(LTR)签证为四类外国人提供 10
                  年可续签签证：富有的全球公民、富有的养老金领取者、在泰国工作的专业人士和高技能专业人士
                  - 须符合申请资格
                </li>
                <li>退休签证，适用于年满 50 岁且符合财务要求的人士</li>
                <li>教育签证，适用于就读于泰国注册教育机构的人士</li>
                <li>商务签证，适用于经营公司的人士</li>
                <li>结婚签证，适用于与泰国人结婚的外籍人士</li>
                <li>
                  泰国精英签证，一项由政府引导的计划，提供包括 5
                  年至20年签证的会籍
                </li>
              </ul>
            </li>
          </ul>
          <p>如需了解更多信息，请咨询移民专家或泰国大使馆/领事馆</p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    displayOn: ["en", "ru", "cn"],
    question: {
      en: "Types and number of units for sale?",
      ru: "Тип недвижимости и количество квартир в проекте?",
      cn: "出售单位的房型有哪些，数量是多少？",
    },
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> The development includes three (3) low-rise
            condominium buildings comprising a total of approximately 400 units
            with each building containing approximately 130 units. Studio, one
            and two bedroom configurations are available ranging in size from 29
            – 60 square metres.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Проект включает в себя три (3) малоэтажных
            здания кондоминиума, включающие в общей сложности около 400 квартир,
            в каждом здании примерно 140 квартир. Студия, конфигурации с одной и
            двумя спальнями площадью 28 – 60 кв.м.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            开发项目包括三（3）栋低层公寓楼，共约400套，每栋楼约130套。一室单间公寓、一卧套房和两卧套房配置可选，面积从29至60平方米不等。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en: "How long does construction take?",
      ru: "Сколько времени занимает строительство?",
      cn: "施工需要多长时间？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Construction can only commence once the relevant
            government environmental and building approvals are obtained and is
            estimated to take approximately 20-24 months for each building to
            complete from the commencement date.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Строительство может начаться только после того,
            как будут получены соответствующие правительственные экологические и
            строительные разрешения и согласования. Как правило, с момента
            начала до момента окончания строительных работ и благоустройства
            территории проходит приблизительно 24 месяца.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            获得政府相关的环境与建筑物审批后，建筑工程即可开始施工，估计从生效日期算起、需要大约20-24个月才能完成。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en: "Is a warranty period offered?",
      ru: "Предусмотрен ли гарантийный период?",
      cn: "是否提供保修期？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Yes. A five (5) year building structure warranty
            is offered from the date of completion of construction. Warranties
            on any other component parts of the building will be subject to a
            two (2) year warranty.
          </p>
          {/* <p>
            <small>
              <em>*Subject to exclusion under contract and law.</em>
            </small>
          </p> */}
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Да, предоставляется гарантия на конструкцию
            здания сроком на пять (5) лет с момента завершения строительства.
            Гарантия на любые другие составные части здания составит два (2)
            года.
          </p>
          <p>
            <small>
              <em>
                *Могут быть внесены изменения в соответствии с договором и
                законодательством.
              </em>
            </small>
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            是。从建成施工之日起，提供五（5）年的建筑结构保修。建筑的其他部分将有二（2）年的
            保修期。
          </p>
          {/* <p>
            <small>
              <em>*需遵守合同与法律条文规定的各项排除规定。</em>
            </small>
          </p> */}
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en: "What is included in the property?",
      ru: "Что влючено в покупку недвижимости?",
      cn: "该物业包括什么?",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Fixed furnishings (wardrobes, kitchen cabinets
            and built-in appliances) is included. Loose furniture, artworks and
            amenities are not included but are available to purchase separately.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Встроенный вариант включает в себя встроенную
            мебель (шкафы, кухонные шкафы и встроенную кухонную технику,
            кондиционер и т. п.). Мебель, произведения искусства и удобства не
            включены в стоимость, но их можно приобрести отдельно.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong> 包含固定家具(衣柜,
            橱柜和嵌入式家具)。可移动的家具，艺术装饰和其他设施不包含在内，但可单独购买。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: {
      en: "Is customization of the units allowed?",
      ru:
        "Допускается ли изменение планировки в соответствии с индивидуальными требованиями?",
      cn: "是否允许量身定制该物业单位？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> No. The building must be built in accordance
            with building code and permits as issued by the relevant authorities
            so no changes to the external areas or structural items are
            permitted.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Здания должны быть построены в соответствии со
            строительными документациями и разрешениями, выданными
            соответствующими государственными органами, поэтому изменения
            внешних зон или элементов конструкции недопустимы. Изменения
            внутреннего дизайна могут быть разрешены после официальной приемки -
            передачи квартиры владельцу (необходимо одобрение застройщика).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            不允许，建筑物必须按照有关部门所颁发的建筑规范与许可证进行建造，不允许变更其外部区域或结构
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question: {
      en:
        "What infrastructure and common facilities are provided and who will manage these?",
      ru:
        "Какая предоставляется инфраструктура и объекты общего назначения и кто будет управлять?",
      cn: "项目包含哪些基础设施和公共设施？这些设施由谁负责管理？",
    },

    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> The infrastructure and common facilities
            includes roads and drainage, lighting, landscape areas, swimming
            pools, deck areas and water and electricity supplies. Services shall
            include 24 hours on-site security, garbage collection, cleaning and
            maintenance of infrastructure and common facilities or any other
            services as required for the common use or benefit of owners. In
            addition, owners will be entitled to access certain amenities
            including the shuttle bus service. The condominium manager shall be
            Laguna (or its designated manager).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Инфраструктура и объекты общего пользования
            включают в себя дороги, канализацию, освещение, ландшафтные зоны,
            бассейны, площадки, водоснабжение и электроснабжение. Услуги должны
            включать 24-часовую охрану, сбор мусора, уборку и обслуживание
            инфраструктуры и мест общего пользования, а также любые другие
            услуги, необходимые для общего пользования или требуемые в интересах
            владельцев. Кроме того, владельцы будут иметь право доступа к
            определенным удобствам курорта, включая бесплатный транспорт внутри
            курорта. Управляющим кондоминиумом является Laguna (или назначенный
            ею менеджер).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            基础设施与公共设施包括：道路和排水、照明、景观区、游泳池、甲板区与水电供应。服务包括：24小时现场保安、垃圾收集、清洁打扫，以及基础设施和共同设施的维护，或其他任何业主可以共同使用或收益的服务。此外，业主将有权使用一些设施，包括穿梭巴士服务。公寓经理将由乐古浪房（或其指派之经理）担任。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question: {
      en:
        "What are the estimated fees payable for the infrastructure, common facilities and services provided?",

      ru:
        "Каковы сборы за обслуживание инфраструктуры проекта, общественной территории и за другие предоставляемые услуги?",
      cn: "基础设施、公共设施和相关服务预计费用是多少？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> The fees for the cost of maintenance for the
            infrastructure, common facilities, services provided (“common area
            fee”) and maintenance fees towards other services and facilities
            supplied to the condominium “non-common area fees’ in aggregate
            shall be Baht 60 per square metre per month for the initial year and
            may be subject to change based upon the actual expenses incurred
            from time to time. The annual fees are determined by the total
            expenses incurred and proportionately divided amongst the sellable
            area of the units in the condominium.
          </p>
          <p>
            In addition, a fund shall be established for the cost of major
            repairs, replacement and/or improvement for the infrastructure and
            common facilities (“special fund”). Contributions will be made on a
            regular basis so that the fund is built up over time. The rate shall
            be Baht 100 per square metre per year for the initial year and may
            be subject to change. If the fund balance is not sufficient for the
            cost of major repairs, owners may be required to pay an additional
            amount as requested by the manager from time to time.
          </p>
          <p>
            The cost of water and electricity supplied to individual properties
            shall be based upon metered consumption.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Сбор за обслуживание общей территории составляет
            60 батов за квадратный метр в год в течение первого года и может
            быть изменен согласно фактическим расходам. Годовая плата
            определяется общим объемом расходов и пропорционально разделяется
            между всеми владельцами.
          </p>
          <p>
            Кроме того, для каждого проекта создается амортизационный фонд. Цель
            амортизационного фонда - накопление средств на капитальный ремонт
            инфраструктуры и/или улучшения, которые будет решено сделать в
            будущем. Размер взносов составляет 100 батов за квадратный метр в
            год в течение первого года и может быть пересмотрен. Если остатка
            средств фонда будет недостаточно для покрытия расходов на масштабные
            ремонтные работы, владельцам может потребоваться внести
            дополнительную сумму по требованию управляющего.
          </p>
          <p>
            Плата за водо- и электроснабжение отдельных квартир должна взиматься
            в соответствии с показаниями счетчиков.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            第一年为基础设施、共同设施、提供服务(“公共区域服务费”)的物业维护成本，
            加上向公寓其他“非公共区域费”提供的服务与设施之维护费用，初始合计每平方米每年
            60泰铢，可能会根据不同时期需要的实际费用而有所变更。年费由所发生的费用总额决
            定，并按销售面积按比例分配给个单位。
          </p>
          <p>
            另外，还应为基础设施与共同设施的主要维修、以及其更换和/或改造费用设立基金
            (“特别基金”)。该基金要求业主定期支付从而不断积攒。初始年度费用应为每平方米
            100泰铢，可能会有所变动。如果基金的余额不足以进行大修缮时，则业主可能需要根据
            管理方的要求、不时支付额外的维修费。
          </p>
          <p>供应给各公寓的水电费用，应以计量消费为准。</p>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question: {
      en: "What property management services are provided?",
      ru: "Какие предоставляются услуги по управлению собственностью?",
      cn: "所提供的物业管理服务有哪些？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Laguna will provide a full range of property
            services to individual owners including, pest control, routine and
            preventative maintenance, general repairs, housekeeping and other
            reasonable requests. Rates vary according to the frequency and scope
            of service. In addition, Laguna provides owners with the ability to
            generate a rental income from their property with short-term* and
            long-term rentals (see below).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Управляющая компания Laguna и/или сотрудники
            комплекса Skypark Phuket предоставят полный спектр услуг, включая
            борьбу с вредителями, стандартное и профилактическое обслуживание,
            общие ремонтные работы, уборку и другие виды работ по просьбе
            владельца. Стоимость услуг зависит от частоты масштаба их
            предоставления. Более того, отдел по аренде «Laguna Rentals»
            предоставляет владельцам квартир, не входящих в состав отеля,
            возможность получать дополнительный доход от сдачи их недвижимости в
            долгосрочную и краткосрочную аренду* (см. ниже).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            乐古浪将为个体业主提供全方位的物业管理服务，包括虫害防治、常规与预防性维护、一般维修、家政服务，以及其他合理要求。收费视服务的频率与范围而异。此外，通过乐古浪团队可让业主在住宅空置时以短期*和长期出租（见下文）的方式获取租金收益。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question: {
      en: "Can I rent my unit out on my own?",
      ru: "Могу ли я самостоятельно сдать в аренду свою квартиру?",
      cn: "我是否可以自行租赁我的单位？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Yes, owners may rent out their property on a
            long-term basis (6 months or more) directly or through external
            agents.
          </p>
          <p>
            For short-term* rentals less than 6 months, these must be conducted
            exclusively through Laguna Rentals who provides owners with the
            ability to generate a rental income from their property when not in
            residence with short-term and long-term rentals.
          </p>
          <p>
            <em>* Terms and conditions apply</em>
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Да. В случае сдачи в аренду на длительный срок
            (6 месяцев и более) нет никаких ограничений, сдача в аренду может
            быть произведена владельцем или сторонним агентом.
          </p>
          <p>
            В случае краткосрочной* аренды от 1 до 6 месяцев, все операции
            должны осуществляться через отдел по аренде Laguna Rentals,
            предоставляющий владельцам жилой недвижимости, не являющихся частью
            отеля, возможность получения дополнительного дохода с аренды их
            собственности, если те не проживают там в течение короткого или
            длительного периода.
          </p>
          <p>
            Сдача в аренду на короткий* срок менее 30 дней должна осуществляться
            исключительно через программу аренды Skypark Phuket (владеющая
            гостиничной лицензией). В квартирах, управляемых в соответствии с
            гостиничной программой сдачи в аренду, должен присутствовать
            стандартный набор мебели.
          </p>
          <p>
            <em>* Применяются определенные правила и условия.</em>
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            答.是的，业主可以直接或通过外部中介长期（6个月或更长时间）出租其房产。
          </p>
          <p>
            对于低于6个月的短期*租赁，业主就必须通过乐古浪租赁（Laguna
            Rentals）来进行。这使业主能够在不居住期间，通过短期和长期租赁从其房产中获得租金收入。
          </p>
          <p>
            <em>* 需受一定条款与条件约束。</em>
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question: {
      en:
        "What are the taxes levied on rental income that an owner will be subject to?",
      ru:
        "Какие налоги должен будет выплачивать владелец с дохода от сдачи в аренду?",
      cn: "业主需要缴纳哪些租金收入税？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Owners may be required to file an income tax
            return in Thailand based upon rental income earned and pay the
            applicable tax. Rental distributions made to owners may be subject
            to withholding tax under the Thai Revenue Code with rates ranging
            from 5 – 15%, subject to owners tax structure status.
          </p>
          <small>
            <em>
              Note: applicable tax rates are current at the date of issue of
              this FAQ and may be subject to changes. The unit owner shall be
              responsible for any income and any other taxes, duties and fees of
              whatever nature which may be levied by relevant authorities on the
              unit in connection with the rental.
            </em>
          </small>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Доходы с аренды, получаемые зарубежными
            гражданами, облагаются налогом в 15%. Доходы с аренды, получаемые
            гражданами Таиланда, облагаются налогом в 5%.
          </p>
          <small>
            <em>
              Примечание: приведенные налоговые ставки являются действующими на
              момент публикации данного документа с часто задаваемыми вопросами
              и могут быть пересмотрены. Владельцы собственности несут
              ответственность за получаемые доходы и уплату разнообразных
              налогов, пошлин и сборов, которые могут взиматься соответствующими
              государственными органами в связи со сдачей собственности в
              аренду.
            </em>
          </small>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            业主需要根据所赚取的租金收入在泰国提交所得税申报表并支付适用的税款。根据泰国税
            法，向业主分配的租金需要缴纳 5% 至 15%
            的税费，具体取决于业主的税收结构状况。
          </p>
          <small>
            <em>
              备注：适用的税率是本常见问题解答发布之日的现行税率，可能会有所变化。房屋持有者应对有关
              当局可能对单位征收的与租金有关的任何收入和任何其他税收、关税和费用负责。
            </em>
          </small>
        </div>
      ),
    },
  },
  {
    categoryId: 4,
    question: {
      en: "What privileges will I receive as an owner?",
      ru: " Какие привилегии я получу как владелец?",
      cn: "作为业主，我能享受何特权？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            Owners will receive membership to the Banyan Group’s signature
            property owners’ program, the Sanctuary Club*, which entitles owners
            to discounts and privileges at the Group’s resorts, spas and
            galleries worldwide including:
          </p>
          <ul>
            <li>
              30% discount on best available rates for hotel accommodation
            </li>
            <li>30% discount on golf green fees</li>
            <li>25% discount on food and beverage</li>
            <li>20% discount on a-la-carte spa menu</li>
            <li>15% discount on gallery merchandise</li>
            <li>15% discount on in-house tours</li>
            <li>15% discount on laundry</li>
            <li>10% discount airport transfers</li>
            <li>Priority wait-list on reservations</li>
            <li>Early check-in / late check-out</li>
          </ul>
          <small>
            <em>* Terms and conditions apply.</em>
          </small>
        </div>
      ),
      ru: (
        <div>
          <p>
            Владельцы станут членами особой программы компании Banyan Group -
            Sanctuary Club*, предоставляющей скидки и привилегии на курортах
            компании, в спа-центрах и галереях по всему миру, включая:
          </p>
          <ul>
            <li>скидка 30% от лучших доступных цен на проживание в отелях;</li>
            <li>скидка 25% на еду и напитки;</li>
            <li>скидка 30% от на гольф;</li>
            <li>скидка 20% на комплекс спа-процедур à la carte;</li>
            <li>скидка 15% на покупки в торговой галерее;</li>
            <li>скидка 15% от стоимости организуемых компанией экскурсий;</li>
            <li>скидка 15% на услуги прачечной;</li>
            <li>
              скидка 10% от стоимости трансфера от/до аэропорта или паромного
              терминала;
            </li>
            <li>приоритет в листе ожиданий при бронированиях;</li>
            <li>ранний заезд / поздний выезд</li>
          </ul>
          <p>
            Владельцам, участвующим в гостиничной программе по сдаче жилья в
            аренду, будет предоставлена возможность обменять часть своих годовых
            прав на собственность на бесплатное пребывание в участвующих в
            программе обмена*, направлениях по всему миру.
          </p>
          <small>
            <em>* Применяются определенные правила и условия.</em>
          </small>
        </div>
      ),
      cn: (
        <div>
          <p>
            业主将成为悦榕集团专属的“榕源会俱乐部”会员，获得全球集团品牌旗下的度假村,
            Spa 和艺品阁的折扣和特权:，包括：
          </p>
          <ul>
            <li>酒店住宿最优房价再打 7 折</li>
            <li>食物和饮料 7.5 折</li>
            <li>高尔夫果岭费 7 折</li>
            <li>单点水疗护理 8 折</li>
            <li>艺廊作品 8.5 折</li>
            <li>酒店内导览 8.5 折</li>
            <li>洗衣房 8.5 折</li>
            <li>机场和轮渡码头接送 9 折</li>
            <li>预定等候名单排队优先权</li>
            <li>提前入住/延迟</li>
          </ul>
          <small>
            <em>* 需受一定条款与条件约束</em>
          </small>
        </div>
      ),
    },
  },
  {
    categoryId: 5,
    question: {
      en: "What are the terms of payment?",
      ru: "Каковы условия оплаты?",
      cn: "付款方式是什么？",
    },
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> There are 2 options available:
          </p>
          <p>
            <strong>
              Option 1: 100% Payment upon purchase / during construction
            </strong>
            <br />
            100% payment upon purchase for already completed properties.
            Progressive payments for properties under construction are as per
            the table below.
          </p>
          <table>
            <thead>
              <tr>
                <th>Construction Payment Term</th>
                <th className="th-col2">Of Selling Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>st</sup> Payment upon signing contract
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>nd</sup> Payment when construction is 25% complete
                  <sup>1</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  3<sup>rd</sup> Payment when construction is 50% complete
                  <sup>2</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  4<sup>th</sup> Payment when construction is 75% complete
                  <sup>3</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  5<sup>th</sup> Payment upon completion of construction
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>Total</td>
                <td className="td-col2">100%</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>1. Concrete structure substantially completed</small>
            </li>
            <li>
              <small>
                2. Roof, brickwork and rendering substantially completed
              </small>
            </li>
            <li>
              <small>
                3. Electrical conduits, pipework and plastering substantially
                completed
              </small>
            </li>
          </ol>
          <p>
            <strong>
              Option 2: 50% payment upon purchase / during construction with 50%
              deferred payment over 1, 3 or 5 years
            </strong>
            <br />
            50% payment upon purchase for already completed properties.
            Progressive payments for properties under construction (50% during
            construction / 50% post construction) as per the table below.
          </p>
          <table>
            <thead>
              <tr>
                <th>Deferred Payment Plan</th>
                <th className="th-col2">Of Selling Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>st</sup> Payment upon signing contract
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>nd</sup> Payment when construction is 25% complete
                  <sup>1</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  3<sup>rd</sup> Payment when construction is 50% complete
                  <sup>2</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  4<sup>th</sup> Payment when construction is 75% complete
                  <sup>3</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  Post construction payments
                  <sup>4</sup>
                </td>
                <td className="td-col2">50%</td>
              </tr>
            </tbody>
          </table>
          <table>
            <thead>
              <tr>
                <th>Financing Options</th>
                <th className="th-col2">
                  Interest Rate
                  <br />
                  (per annum)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 Year (4 quarterly installments)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3 Year (12 quarterly installments)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5 Year (20 quarterly installments)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>1. Concrete structure substantially completed</small>
            </li>
            <li>
              <small>
                2. Roof, brickwork and rendering substantially completed
              </small>
            </li>
            <li>
              <small>
                3. Electrical conduits, pipework and plastering substantially
                completed
              </small>
            </li>
            <li>
              <small>4. See table below</small>
            </li>
          </ol>
          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>Price</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Reservation Deposit</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    Construction Completion
                    <br />
                    Payment 50% (Minus Deposit)
                  </strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Remaining Post Finance 50%</strong>
                </td>
                <td colSpan="3" className="td-group-title">
                  <strong>Quarterly Installment</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1 Year (3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3 Year (5%)</strong>
                </td>
                <td>
                  <strong>5 Year (7%)</strong>
                </td>
              </tr>
              <tr>
                <td>4,000,000</td>
                <td>100,000</td>
                <td>1,900,000</td>
                <td>2,000,000</td>
                <td>509,410</td>
                <td>180,517</td>
                <td>119,382</td>
              </tr>
              <tr>
                <td>4,500,000</td>
                <td>100,000</td>
                <td>2,150,000</td>
                <td>2,250,000</td>
                <td>573,086</td>
                <td>203,081</td>
                <td>134,305</td>
              </tr>
              <tr>
                <td>5,000,000</td>
                <td>100,000</td>
                <td>2,400,000</td>
                <td>2,500,000</td>
                <td>636,763</td>
                <td>225,646</td>
                <td>149,228</td>
              </tr>
              <tr>
                <td>5,500,000</td>
                <td>100,000</td>
                <td>2,650,000</td>
                <td>2,750,000</td>
                <td>700,439</td>
                <td>248,210</td>
                <td>164,151</td>
              </tr>
              <tr>
                <td>6,000,000</td>
                <td>100,000</td>
                <td>2,900,000</td>
                <td>3,000,000</td>
                <td>764,115</td>
                <td>270,775</td>
                <td>179,074</td>
              </tr>
              <tr>
                <td>6,500,000</td>
                <td>100,000</td>
                <td>3,150,000</td>
                <td>3,250,000</td>
                <td>827,791</td>
                <td>293,340</td>
                <td>193,996</td>
              </tr>
              <tr>
                <td>7,000,000</td>
                <td>100,000</td>
                <td>3,400,000</td>
                <td>3,500,000</td>
                <td>891,468</td>
                <td>315,904</td>
                <td>208,919</td>
              </tr>
              <tr>
                <td>7,500,000</td>
                <td>100,000</td>
                <td>3,650,000</td>
                <td>3,750,000</td>
                <td>955,144</td>
                <td>338,469</td>
                <td>223,842</td>
              </tr>
              <tr>
                <td>8,000,000</td>
                <td>100,000</td>
                <td>3,900,000</td>
                <td>4,000,000</td>
                <td>1,018,820</td>
                <td>361,033</td>
                <td>238,765</td>
              </tr>
              <tr>
                <td>8,500,000</td>
                <td>100,000</td>
                <td>4,150,000</td>
                <td>4,250,000</td>
                <td>1,082,496</td>
                <td>383,598</td>
                <td>253,688</td>
              </tr>
              <tr>
                <td>9,000,000</td>
                <td>100,000</td>
                <td>4,400,000</td>
                <td>4,500,000</td>
                <td>1,146,173</td>
                <td>406,162</td>
                <td>268,611</td>
              </tr>
              <tr>
                <td>9,500,000</td>
                <td>100,000</td>
                <td>4,650,000</td>
                <td>4,750,000</td>
                <td>1,209,849</td>
                <td>428,727</td>
                <td>283,533</td>
              </tr>
              <tr>
                <td>10,000,000</td>
                <td>100,000</td>
                <td>4,900,000</td>
                <td>5,000,000</td>
                <td>1,273,525</td>
                <td>451,292</td>
                <td>298,456</td>
              </tr>
              <tr>
                <td>10,500,000</td>
                <td>100,000</td>
                <td>5,150,000</td>
                <td>5,250,000</td>
                <td>1,337,201</td>
                <td>473,856</td>
                <td>313,379</td>
              </tr>
              <tr>
                <td>11,000,000</td>
                <td>100,000</td>
                <td>5,400,000</td>
                <td>5,500,000</td>
                <td>1,400,878</td>
                <td>496,421</td>
                <td>328,302</td>
              </tr>
              <tr>
                <td>11,500,000</td>
                <td>100,000</td>
                <td>5,650,000</td>
                <td>5,750,000</td>
                <td>1,464,554</td>
                <td>518,985</td>
                <td>343,225</td>
              </tr>
              <tr>
                <td>12,000,000</td>
                <td>100,000</td>
                <td>5,900,000</td>
                <td>6,000,000</td>
                <td>1,528,230</td>
                <td>541,550</td>
                <td>358,147</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>1. All amounts are stated in Thai Baht (THB).</small>
            </li>
            <li>
              <small>
                2. The above table sets out the estimated payments required
                under the respective payment plans for selling prices between
                THB 4,000,000 – 12,000,000.
              </small>
            </li>
            <li>
              <small>
                3. The estimated payments are indicative only and the developer
                / seller does not accept any responsibility or liability
                whatsoever for any inaccuracies or omissions.
              </small>
            </li>
            <li>
              <small>
                4. Payment terms are subject to change without notice.
              </small>
            </li>
          </ol>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Существуют два варианта:
          </p>
          <p>
            <strong>
              Вариант 1: 100%-ная оплата в момент покупки / в период
              строительства
            </strong>
            <br />
            100%-оплата при покупке уже готового объекта. Прогрессивные платежи
            для строящихся объектов см. в таблице ниже.
          </p>
          <table>
            <thead>
              <tr>
                <th>Срок платежа на момент строительства</th>
                <th className="th-col2">% от цены продажи</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1-ый платеж при заключении договора</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2-ой платеж при 25 %-ной готовности объекта
                  <sup>3</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  3-ий платеж при 50 %-ной готовности объекта
                  <sup>4</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  4-ый платеж при 75 %-ной готовности объекта
                  <sup>5</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>5-ый платеж по окончании строительства</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>Всего</td>
                <td className="td-col2">100%</td>
              </tr>
            </tbody>
          </table>
          <small>Примечания:</small>
          <ol className="notes">
            <li>
              <small>
                1. Площади и размеры указаны приблизительно и могут изменяться
                по итогам финальных измерений.
              </small>
            </li>
            <li>
              <p style={{ margin: 0 }}>
                <small>
                  2. БАЗОВЫЙ вариант: встроенные бытовые приборы, сантехника и
                  техника НЕ включены при покупке обьекта недвижимости. Вариант
                  СО ВСТРОЕННОЙ МЕБЕЛЬЮ: встроенные бытовые приборы, сантехника
                  и техника включены при покупке обьекта недвижимости.
                </small>
              </p>
              <p style={{ margin: 0 }}>
                <small>
                  МЕБЛИРОВАННЫЙ вариант: встроенная мебель, сантехника, техника
                  и невстроенная мебель включены при покупке обьекта
                  недвижимости.
                </small>
              </p>
            </li>
            <li>
              <small>3. Бетонная конструкция в основном завершена.</small>
            </li>
            <li>
              <small>
                4. Крыша, укладка кирпича и наружная отделка в основном
                завершены.
              </small>
            </li>
            <li>
              <small>
                5. Электрическая проводка, укладка водопроводных труб и
                внутренняя отделка в основном завершены.
              </small>
            </li>
            <li>
              <small>
                6. Проценты по рассрочке будут начислены на отложенные платежи
                по окончании строительства, как указано в таблице «Варианты
                финансирования»
              </small>
            </li>
          </ol>
          <p>
            <strong>
              Вариант 2: Оплата 50% при покупке уже готовой недвижимости.
              Прогрессивные платежи за объекты незавершенного строительства (50%
              во время строительства / 50% после строительства) согласно таблице
              ниже.
            </strong>
            <br />
            Прогрессивные платежи для строящихся объектов (50% в период
            строительства / 50% по окончании строительства) см. в таблице ниже.
          </p>
          <table>
            <thead>
              <tr>
                <th>График отложенных платежей</th>
                <th className="th-col2">% от цены продажи</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1-й платеж при заключении договора</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2-й платеж при 25%-ной готовности объекта
                  <sup>3</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  3-й платеж при 50%-ной готовности объекта
                  <sup>4</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  4-й платеж при 75%-ной готовности объекта
                  <sup>5</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  Платежи по окончании строительства
                  <sup>6</sup>
                </td>
                <td className="td-col2">50%</td>
              </tr>
            </tbody>
          </table>
          <small>Примечания:</small>
          <ol className="notes">
            <li>
              <small>
                1. Площади и размеры указаны приблизительно и могут изменяться
                по итогам финальных измерений.
              </small>
            </li>
            <li>
              <p style={{ margin: 0 }}>
                <small>
                  2. БАЗОВЫЙ вариант: встроенные бытовые приборы, сантехника и
                  техника НЕ включены при покупке обьекта недвижимости. Вариант
                  СО ВСТРОЕННОЙ МЕБЕЛЬЮ: встроенные бытовые приборы, сантехника
                  и техника включены при покупке обьекта недвижимости.
                </small>
              </p>
              <p style={{ margin: 0 }}>
                <small>
                  МЕБЛИРОВАННЫЙ вариант: встроенная мебель, сантехника, техника
                  и невстроенная мебель включены при покупке обьекта
                  недвижимости.
                </small>
              </p>
            </li>
            <li>
              <small>3. Бетонная конструкция в основном завершена.</small>
            </li>
            <li>
              <small>
                4. Крыша, укладка кирпича и наружная отделка в основном
                завершены.
              </small>
            </li>
            <li>
              <small>
                5. Электрическая проводка, укладка водопроводных труб и
                внутренняя отделка в основном завершены.
              </small>
            </li>
            <li>
              <small>
                6. Проценты по рассрочке будут начислены на отложенные платежи
                по окончании строительства, как указано в таблице «Варианты
                финансирования»
              </small>
            </li>
          </ol>
          <table>
            <thead>
              <tr>
                <th>Рассрочка</th>
                <th className="th-col2">
                  Процентная ставка
                  <br />
                  (в год)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 год (4 ежеквартальных платежа)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3 года (12 ежеквартальных платежей)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5 лет (20 ежеквартальных платежей)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>Цена</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Резервационный депозит</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    Платеж по окончании строительства 50%
                    <br />
                    (минус депозит)
                  </strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Рассрочка после окончания строительства 50%</strong>
                </td>
                <td colSpan="3" className="td-group-title">
                  <strong>Ежеквартальный платеж</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1 Year (3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3 Year (5%)</strong>
                </td>
                <td>
                  <strong>5 Year (7%)</strong>
                </td>
              </tr>
              <tr>
                <td>4,000,000</td>
                <td>100,000</td>
                <td>1,900,000</td>
                <td>2,000,000</td>
                <td>509,410</td>
                <td>180,517</td>
                <td>119,382</td>
              </tr>
              <tr>
                <td>4,500,000</td>
                <td>100,000</td>
                <td>2,150,000</td>
                <td>2,250,000</td>
                <td>573,086</td>
                <td>203,081</td>
                <td>134,305</td>
              </tr>
              <tr>
                <td>5,000,000</td>
                <td>100,000</td>
                <td>2,400,000</td>
                <td>2,500,000</td>
                <td>636,763</td>
                <td>225,646</td>
                <td>149,228</td>
              </tr>
              <tr>
                <td>5,500,000</td>
                <td>100,000</td>
                <td>2,650,000</td>
                <td>2,750,000</td>
                <td>700,439</td>
                <td>248,210</td>
                <td>164,151</td>
              </tr>
              <tr>
                <td>6,000,000</td>
                <td>100,000</td>
                <td>2,900,000</td>
                <td>3,000,000</td>
                <td>764,115</td>
                <td>270,775</td>
                <td>179,074</td>
              </tr>
              <tr>
                <td>6,500,000</td>
                <td>100,000</td>
                <td>3,150,000</td>
                <td>3,250,000</td>
                <td>827,791</td>
                <td>293,340</td>
                <td>193,996</td>
              </tr>
              <tr>
                <td>7,000,000</td>
                <td>100,000</td>
                <td>3,400,000</td>
                <td>3,500,000</td>
                <td>891,468</td>
                <td>315,904</td>
                <td>208,919</td>
              </tr>
              <tr>
                <td>7,500,000</td>
                <td>100,000</td>
                <td>3,650,000</td>
                <td>3,750,000</td>
                <td>955,144</td>
                <td>338,469</td>
                <td>223,842</td>
              </tr>
              <tr>
                <td>8,000,000</td>
                <td>100,000</td>
                <td>3,900,000</td>
                <td>4,000,000</td>
                <td>1,018,820</td>
                <td>361,033</td>
                <td>238,765</td>
              </tr>
              <tr>
                <td>8,500,000</td>
                <td>100,000</td>
                <td>4,150,000</td>
                <td>4,250,000</td>
                <td>1,082,496</td>
                <td>383,598</td>
                <td>253,688</td>
              </tr>
              <tr>
                <td>9,000,000</td>
                <td>100,000</td>
                <td>4,400,000</td>
                <td>4,500,000</td>
                <td>1,146,173</td>
                <td>406,162</td>
                <td>268,611</td>
              </tr>
              <tr>
                <td>9,500,000</td>
                <td>100,000</td>
                <td>4,650,000</td>
                <td>4,750,000</td>
                <td>1,209,849</td>
                <td>428,727</td>
                <td>283,533</td>
              </tr>
              <tr>
                <td>10,000,000</td>
                <td>100,000</td>
                <td>4,900,000</td>
                <td>5,000,000</td>
                <td>1,273,525</td>
                <td>451,292</td>
                <td>298,456</td>
              </tr>
              <tr>
                <td>10,500,000</td>
                <td>100,000</td>
                <td>5,150,000</td>
                <td>5,250,000</td>
                <td>1,337,201</td>
                <td>473,856</td>
                <td>313,379</td>
              </tr>
              <tr>
                <td>11,000,000</td>
                <td>100,000</td>
                <td>5,400,000</td>
                <td>5,500,000</td>
                <td>1,400,878</td>
                <td>496,421</td>
                <td>328,302</td>
              </tr>
              <tr>
                <td>11,500,000</td>
                <td>100,000</td>
                <td>5,650,000</td>
                <td>5,750,000</td>
                <td>1,464,554</td>
                <td>518,985</td>
                <td>343,225</td>
              </tr>
              <tr>
                <td>12,000,000</td>
                <td>100,000</td>
                <td>5,900,000</td>
                <td>6,000,000</td>
                <td>1,528,230</td>
                <td>541,550</td>
                <td>358,147</td>
              </tr>
            </tbody>
          </table>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong> 提供 2 种选择：
          </p>
          <p>
            <strong>选择 1：购买/施工期间全额付款</strong>
            <br />
            对于已建成物业，依据购买价格
            100%付款。对于在建物业，依据下表按进度分期付款。
          </p>
          <table>
            <thead>
              <tr>
                <th>施工付款条款</th>
                <th className="th-col2">付款比例</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>签署合同时进行首付</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>工程完成 25% 1 时进行第 2 次付款</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>工程完成 50% 2 时进行第 3 次付款</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>工程完成 75% 3 时进行第 4 次付款</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>竣工时进行第 5 次付款</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>合计</td>
                <td className="td-col2">100%</td>
              </tr>
            </tbody>
          </table>
          <small>注释：</small>
          <ol className="notes">
            <li>
              <small>
                <em>1. 混凝土框架大体完成 </em>
              </small>
            </li>
            <li>
              <small>
                <em>2. 屋顶、砖砌和抹灰作业大体完成 </em>
              </small>
            </li>
            <li>
              <small>
                <em>3. 电路，管道作业和抹灰大体完成</em>
              </small>
            </li>
          </ol>
          <p>
            <strong>
              选择 2：购买时/施工期间付款 50%，剩余的 50% 延期款项在 1 年、3
              年或 5 年内支付
            </strong>
            <br />
            购买已竣工物业时支付 50%
            的款项。按下表为尚在施工的项目分期付款（施工期间付款 50%/竣工后付款
            50%）。
          </p>

          <table>
            <thead>
              <tr>
                <th>延期付款计划</th>
                <th className="th-col2">付款比例</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>签署合同时进行第 1 次付款</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>工程完成 25% 时进行第2次付款</td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>工程完成 50% 时进行第3次付款</td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>工程完成 75% 时进行第4次付款</td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>竣工后付款</td>
                <td className="td-col2">50%</td>
              </tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr>
                <th>延期付款选择</th>
                <th className="th-col2">利率（每年）</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 年（4个季度分期付款）</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3 年（12个季度期付款）</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5 年（20个季度分期付款）</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>
            <em>注释：</em>
          </small>
          <ol className="notes">
            <li>
              <small>
                <em>1. 混凝土架构大体完成</em>
              </small>
            </li>
            <li>
              <small>
                <em>2. 屋顶,砖砌和抹灰作业大体完成</em>
              </small>
            </li>
            <li>
              <small>
                <em>3. 电路，管道和抹灰作业大体完成</em>
              </small>
            </li>
            <li>
              <small>
                <em>4. 参见下表</em>
              </small>
            </li>
          </ol>

          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>价格</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>预定金</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    竣工时付款 50%
                    <br />
                    （减去定金）
                  </strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>之后以延期付款形式支付剩余的 50% 款项</strong>
                </td>
                <td colSpan="3" className="td-group-title">
                  <strong>按月付款</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1年(3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3年(5%)</strong>
                </td>
                <td>
                  <strong>5年(7%)</strong>
                </td>
              </tr>
              <tr>
                <td>4,000,000</td>
                <td>100,000</td>
                <td>1,900,000</td>
                <td>2,000,000</td>
                <td>509,410</td>
                <td>180,517</td>
                <td>119,382</td>
              </tr>
              <tr>
                <td>4,500,000</td>
                <td>100,000</td>
                <td>2,150,000</td>
                <td>2,250,000</td>
                <td>573,086</td>
                <td>203,081</td>
                <td>134,305</td>
              </tr>
              <tr>
                <td>5,000,000</td>
                <td>100,000</td>
                <td>2,400,000</td>
                <td>2,500,000</td>
                <td>636,763</td>
                <td>225,646</td>
                <td>149,228</td>
              </tr>
              <tr>
                <td>5,500,000</td>
                <td>100,000</td>
                <td>2,650,000</td>
                <td>2,750,000</td>
                <td>700,439</td>
                <td>248,210</td>
                <td>164,151</td>
              </tr>
              <tr>
                <td>6,000,000</td>
                <td>100,000</td>
                <td>2,900,000</td>
                <td>3,000,000</td>
                <td>764,115</td>
                <td>270,775</td>
                <td>179,074</td>
              </tr>
              <tr>
                <td>6,500,000</td>
                <td>100,000</td>
                <td>3,150,000</td>
                <td>3,250,000</td>
                <td>827,791</td>
                <td>293,340</td>
                <td>193,996</td>
              </tr>
              <tr>
                <td>7,000,000</td>
                <td>100,000</td>
                <td>3,400,000</td>
                <td>3,500,000</td>
                <td>891,468</td>
                <td>315,904</td>
                <td>208,919</td>
              </tr>
              <tr>
                <td>7,500,000</td>
                <td>100,000</td>
                <td>3,650,000</td>
                <td>3,750,000</td>
                <td>955,144</td>
                <td>338,469</td>
                <td>223,842</td>
              </tr>
              <tr>
                <td>8,000,000</td>
                <td>100,000</td>
                <td>3,900,000</td>
                <td>4,000,000</td>
                <td>1,018,820</td>
                <td>361,033</td>
                <td>238,765</td>
              </tr>
              <tr>
                <td>8,500,000</td>
                <td>100,000</td>
                <td>4,150,000</td>
                <td>4,250,000</td>
                <td>1,082,496</td>
                <td>383,598</td>
                <td>253,688</td>
              </tr>
              <tr>
                <td>9,000,000</td>
                <td>100,000</td>
                <td>4,400,000</td>
                <td>4,500,000</td>
                <td>1,146,173</td>
                <td>406,162</td>
                <td>268,611</td>
              </tr>
              <tr>
                <td>9,500,000</td>
                <td>100,000</td>
                <td>4,650,000</td>
                <td>4,750,000</td>
                <td>1,209,849</td>
                <td>428,727</td>
                <td>283,533</td>
              </tr>
              <tr>
                <td>10,000,000</td>
                <td>100,000</td>
                <td>4,900,000</td>
                <td>5,000,000</td>
                <td>1,273,525</td>
                <td>451,292</td>
                <td>298,456</td>
              </tr>
              <tr>
                <td>10,500,000</td>
                <td>100,000</td>
                <td>5,150,000</td>
                <td>5,250,000</td>
                <td>1,337,201</td>
                <td>473,856</td>
                <td>313,379</td>
              </tr>
              <tr>
                <td>11,000,000</td>
                <td>100,000</td>
                <td>5,400,000</td>
                <td>5,500,000</td>
                <td>1,400,878</td>
                <td>496,421</td>
                <td>328,302</td>
              </tr>
              <tr>
                <td>11,500,000</td>
                <td>100,000</td>
                <td>5,650,000</td>
                <td>5,750,000</td>
                <td>1,464,554</td>
                <td>518,985</td>
                <td>343,225</td>
              </tr>
              <tr>
                <td>12,000,000</td>
                <td>100,000</td>
                <td>5,900,000</td>
                <td>6,000,000</td>
                <td>1,528,230</td>
                <td>541,550</td>
                <td>358,147</td>
              </tr>
            </tbody>
          </table>
          <small>
            <em>备注: </em>
          </small>
          <ol className="notes">
            <li>
              <small>
                <em>1. 所有示例金额为泰铢.</em>
              </small>
            </li>
            <li>
              <small>
                <em>
                  2. 以上表格为预计付款金额，实际根据物业销售金额（4,000,000 –
                  12,000,000泰铢）的各自付款方案而定。
                </em>
              </small>
            </li>
            <li>
              <small>
                <em>
                  3.
                  预计付款金额仅为参考，开发商或销售员对其中的非准确和遗漏部分不承担任何责任或义务。
                </em>
              </small>
            </li>
            <li>
              <small>
                <em>4. 支付条款若有更改，恕不通知。</em>
              </small>
            </li>
          </ol>
        </div>
      ),
    },
  },
];

export { category, faqs };



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/faq.js